import UIHelper from "general/helpers/UIHelper";
import VoucherBatchDetailView from "../../components/VoucherBatchDetailView";
import useRouter from "hooks/useRouter";

VoucherBatchDetailScreen.propTypes = {};

function VoucherBatchDetailScreen(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();

    return (
        <div>
            <div>
                {UIHelper.buildBreadcrumb([
                    {
                        title: `Danh sách lô voucher`,
                        onPress: () => {
                            router.navigate(-1);
                        },
                    },
                    { title: 'Chi tiết lô voucher' },
                ])}
            </div>
            <div className="my-4">
                <VoucherBatchDetailView />
            </div>
        </div>
    );
}

export default VoucherBatchDetailScreen;
